import { useSelector } from "react-redux";

/**
 * Custom hook to access app configuration
 * @returns {Object} - Contains config data, loading state, and error
 */
const useAppConfig = () => {
  const { config, isLoading, error } = useSelector((state) => state.config);

  return {
    config,
    isLoading,
    error,
    defaultReturnPolicy: config?.defaultReturnPolicy || "",
    defaultReserveProductQuantityInMart: config?.defaultReserveProductQuantityInMart || 10,
    disclaimer: config?.disclaimer || "",
  };
};

export default useAppConfig;
